import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Admin generated or regenerated a SCIM bearer token',
  name: 'scim_token_generated',
  params: [
    {
      description: 'Whether this generation rotated an existing token',
      name: 'is_regenerate',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Location of the generate action',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['workspace-settings-security'],
    },
  ],
};

export default META;
